import { useCallback, useState, memo } from 'react'
import Logo from './svgs/LogoSvg'
import cn from 'classnames/bind'
import Link from 'next/link'

import { FiDownload } from 'react-icons/fi'
import { WEB_SITE_URL, WEB_STORE_URL } from '../../lib/frontend/miscUtils'

const HeaderPublic = memo(function Header () {
  const [hovered, setHovered] = useState(false)

  const onMouseEnter = useCallback(() => setHovered(true), [setHovered])
  const onMouseLeave = useCallback(() => setHovered(false), [setHovered])

  return (
    <div
      className="flex flex-row justify-between bg-gray-50 px-10 py-1 border-b-2 animate__animated animate__fadeInDown"
    >
      <Link href={WEB_SITE_URL}>
        <a
          className="flex flex-row cursor-pointer active:opacity-90"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className={cn('w-12 h-12 mr-4 animate__animated', hovered && 'animate__rubberBand')}>
            <Logo />
          </div>
          <span
            className="text-xl text-listeri-red self-center font-fancy hidden md:inline">
            Free Annotation Tool
          </span>
        </a>
      </Link>
      <a
        className="text-listeri-red border border-listeri-red bg-transparent shadow my-2 px-4 inline-flex items-center justify-center cursor-pointer active:bg-red-300 hover:bg-red-100 hover:bg-opacity-20"
        href={WEB_STORE_URL}
        target="_blank"
        rel="noreferrer noopener"
      >
        <div className="flex animate__animated animate__faster">
          <span className="tracking-widest font-extralight font-fancy flex flex-row mr-4 text-sm">
            <span className="hidden md:inline">
              GET
              THIS
            </span>
            <span className="bg-listeri-red text-white px-1 rounded mx-2 bg-opacity-80">
              FREE
            </span>
            TOOL
          </span>
          <FiDownload className="flex self-center" />
        </div>
      </a>
    </div>
  )
})

export { HeaderPublic }
